import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _hoisted_1 = { class: "brand_culture_value_content" }
const _hoisted_2 = { class: "brand_culture_value_title" }
const _hoisted_3 = { class: "brand_culture_value_boxs" }
const _hoisted_4 = { class: "brand_culture_value_box_number" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "brand_culture_value_box_icon",
  src: _imports_0
}, null, -1)
const _hoisted_6 = { class: "brand_culture_value_box_content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.info.title), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.list, (value, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "brand_culture_value_box",
          key: `value_${index}`
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(value.number), 1),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(value.content), 1)
        ]))
      }), 128))
    ])
  ]))
}